<div class="modal fade" tabindex="-1" role="dialog" id="estoque-amp-filtro">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 translate class="modal-title">{{'parametros.estoqueAMP.filtros.definirFiltros'}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container striped-rows">
            <div class="row ptb5">
              <div translate class="col col-4">
                {{'estoque.relatorioKardex.filtros.dealer'}}
              </div>
              <div class="col col-8">
                <select class="form-control form-control-sm" type="number" [(ngModel)]="Dealer">
                  <option translate value="">{{'estoque.relatorioKardex.filtros.dealerPlaceHolder'}}</option>
                  <option *ngFor="let item of dealers" [value]="item.id">{{item.descricao}}</option>
                </select>
              </div>
            </div>
            <div class="row ptb5">
              <div translate class="col col-4">
                {{'parametros.estoqueAMP.filtros.partNumber'}}
              </div>
              <div class="col col-8">
                <input class="form-control form-control-sm" type="text" placeholder="{{'parametros.estoqueAMP.filtros.partNumberPlaceHolder' | translate}}" [(ngModel)]="filtros.descricao">
              </div>
            </div>
            <div class="row ptb5">
              <div translate class="col col-4">
                {{'parametros.estoqueAMP.filtros.quantidade'}}
              </div>
              <div class="col col-8">
                <input class="form-control form-control-sm" type="number" placeholder="{{'parametros.estoqueAMP.filtros.quantidadePlaceHolder' | translate}}" [(ngModel)]="filtros.quantidade">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="limparFiltros()">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-info" data-dismiss="modal">OK</button>
        </div>
      </div>
    </div>
  </div>